import * as authConstants from './authConstants'

/* ------------- Types ------------- */
export interface CredentialsLogInRequest extends ReturnType<typeof credentialsLogInRequest> {}
export interface ProviderLogInRequest extends ReturnType<typeof providerLogInRequest> {}
export interface HeaderEnrichmentLogInRequest extends ReturnType<typeof headerEnrichmentLogInRequest> {}
export interface LogInRequest extends ReturnType<typeof logInRequest> {}
export interface LogInSuccess extends ReturnType<typeof logInSuccess> {}
export interface LogInError extends ReturnType<typeof logInError> {}
export interface ClearLogInError extends ReturnType<typeof clearLogInError> {}
export interface LogOut extends ReturnType<typeof logOut> {}

export type AuthAction =
  | CredentialsLogInRequest
  | ProviderLogInRequest
  | LogInRequest
  | LogInSuccess
  | LogInError
  | ClearLogInError
  | LogOut

/* ------------- Sub Types ------------- */
export type AuthProvider = 'facebook' | 'google'

export interface Credentials {
  username: string
  password: string
}

/* ------------- Actions ------------- */
export const credentialsLogInRequest = (payload: { credentials: Credentials }) =>
  <const>{
    type: authConstants.CREDENTIAL_LOG_IN_REQUEST,
    ...payload,
  }

export const providerLogInRequest = (payload: { code: string }) =>
  <const>{
    type: authConstants.PROVIDER_LOG_IN_REQUEST,
    ...payload,
  }

export const headerEnrichmentLogInRequest = (payload: { tid: string; errorCallback: () => void }) =>
  <const>{
    type: authConstants.HEADER_ENRICHMENT_LOG_IN_REQUEST,
    ...payload,
  }

export const logInRequest = () =>
  <const>{
    type: authConstants.LOG_IN_REQUEST,
  }

export const logInSuccess = (payload: { accessToken: string }) =>
  <const>{
    type: authConstants.LOG_IN_SUCCESS,
    ...payload,
  }

export const logInError = (payload: { error: string }) =>
  <const>{
    type: authConstants.LOG_IN_ERROR,
    ...payload,
  }

export const clearLogInError = () =>
  <const>{
    type: authConstants.CLEAR_LOG_IN_ERROR,
  }

export const logOut = () =>
  <const>{
    type: authConstants.LOG_OUT,
  }
